import { render, staticRenderFns } from "./ActivityListWide.vue?vue&type=template&id=f2141c22&scoped=true&"
import script from "./ActivityListWide.vue?vue&type=script&lang=js&"
export * from "./ActivityListWide.vue?vue&type=script&lang=js&"
import style0 from "./ActivityListWide.vue?vue&type=style&index=0&id=f2141c22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2141c22",
  null
  
)

export default component.exports